import FormattedMessage from 'I18n/components/FormattedMessage';
import { Small } from 'foundations-components/transitional/components/Small';
import { Flex } from 'foundations-components/components/Flex';
import { hasLimit, isCapacityFull } from '../../utils/capacityUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const TicketCapacity = ({
  capacity
}) => {
  const {
    capacityLoad,
    capacityLimit
  } = capacity;
  return hasLimit(capacity) && /*#__PURE__*/_jsx(Small, {
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      children: [/*#__PURE__*/_jsx(FormattedMessage, {
        message: "routing-ui.agent-status.statusPopover.header.limitTickets",
        options: {
          capacityLoad,
          capacityLimit
        }
      }), isCapacityFull(capacity) && /*#__PURE__*/_jsx(Small, {
        paddingBlockStart: "200",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "routing-ui.agent-status.statusPopover.header.atCapacityDescription"
        })
      })]
    })
  });
};
TicketCapacity.displayName = 'TicketCapacity';
const CategoryCapacity = ({
  capacity
}) => {
  const {
    CALLING,
    REAL_TIME_MESSAGING,
    ASYNC_COMMUNICATION
  } = capacity;
  return /*#__PURE__*/_jsx(Small, {
    children: /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      children: [hasLimit(CALLING) && /*#__PURE__*/_jsx(FormattedMessage, {
        message: "routing-ui.agent-status.statusPopover.header.limitCall",
        options: CALLING,
        "data-test-id": "capacity-call"
      }), hasLimit(REAL_TIME_MESSAGING) && /*#__PURE__*/_jsx(FormattedMessage, {
        message: "routing-ui.agent-status.statusPopover.header.limitMessaging",
        options: REAL_TIME_MESSAGING,
        "data-test-id": "capacity-messaging"
      }), hasLimit(ASYNC_COMMUNICATION) && /*#__PURE__*/_jsx(FormattedMessage, {
        message: "routing-ui.agent-status.statusPopover.header.limitOther",
        options: ASYNC_COMMUNICATION,
        "data-test-id": "capacity-other"
      }), isCapacityFull(REAL_TIME_MESSAGING) && /*#__PURE__*/_jsx(Small, {
        paddingBlockStart: "200",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "routing-ui.agent-status.statusPopover.header.atMessagingCapacityDescription",
          "data-test-id": "capacity-messagingFull"
        })
      })]
    })
  });
};
CategoryCapacity.displayName = 'CategoryCapacity';
export const CapacitySection = ({
  userCapacity
}) => {
  if (userCapacity.type === 'BY_CAPACITY_CATEGORY') {
    return /*#__PURE__*/_jsx(CategoryCapacity, {
      capacity: userCapacity.capacity
    });
  }
  return /*#__PURE__*/_jsx(TicketCapacity, {
    capacity: userCapacity.capacity
  });
};
CapacitySection.displayName = 'CapacitySection';